import "./CompanyInfo.scss";
import Modal from "react-modal";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BeatLoader } from 'react-spinners';
import newRequest from "../../utils/userRequest";
import backendUrl from "../../utils/backendUrl";
import { useTranslation } from 'react-i18next'

const CompanyInfo = ({ inputs, title, permission }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [img1, setImg1] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newImageSelected, setNewImageSelected] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const [updatePermission, setUpdatePermission] = useState(false);
  const { t, i18n } = useTranslation()

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  useEffect(() => {
    newRequest.get("/getCompanyData")
      .then((response) => {
        console.log(response.data);
        setCompanyData(response.data[0] ?? {});
        if (response.data[0]?.logo) {
          let logoVariable = response.data[0].logo;
          const liveURL = backendUrl + "/" + logoVariable.replace(/\\/g, "/");
          setImg1(liveURL);
          console.log(liveURL);
        }
      }
      )
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const navigate = useNavigate();
  const handleSubmit = async event => {
    setIsLoading(true);
    event.preventDefault();

    const form = new FormData();
    const updatedUser = {};

    if (img1 && img1 !== companyData.logo) {
      form.append("logo", img1);
      updatedUser.logo = img1;
    }
    inputs.forEach((input) => {
      const name = input.name;
      const value = event.target[name].value;

      if (companyData != null && value !== companyData[name]) {
        form.append(name, value);
        updatedUser[name] = value;
      }
    });

    console.log(form);

    await newRequest.post("/postCompanyData", form).then((response) => {
      console.log(response.data);
      setCompanyData(prevState => ({ ...prevState, ...updatedUser }));
      setIsLoading(false);
    })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      }
      );


  };
  const handleUpdatePermission = () => {
    setUpdatePermission(!updatePermission);
  };

  return (

    <span
    >
      {isLoading &&
        <div className='loading-spinner-background'>
          <BeatLoader
            size={15}
            color={"#6439ff"}
            // height={4}
            loading={isLoading}
          />
        </div>
      }
       <div className={`updateUser ${i18n.language === 'ar' ? "flex-row-reverse" : 'flex-row'}`}>
        {/* {permission !== "view" && <Sidebar />} */}
        <div className="newContainer">
          {/* <Navbar /> */}
           <div className={`top ${i18n.language === 'ar' ? "flex-row-reverse" : 'flex-row'}`}>
            <h1>{title}</h1>
            <button className="companyUpdateBtn"
              onClick={handleUpdatePermission}
            >
              {!updatePermission ? `${t("Edit Data")}` : `${t("Read Only")}`}
            </button>
          </div>
          <div className={`bottom ${i18n.language === 'ar' ? "flex-row-reverse" : 'flex-row'}`}>
            <div className="left">
              <div className="img-circle-container">

                <img
                  src={
                    img1
                      ? newImageSelected
                        ? URL.createObjectURL(img1)
                        : img1
                      : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"

                  }
                  alt=""
                  className="singleTopImg profile-image"
                  onClick={openModal}
                />

                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="Modal">
                  <span className="img-span">
                    <img
                      src={
                        img1
                          ? newImageSelected
                            ? URL.createObjectURL(img1)
                            : img1
                          : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                      }
                      alt=""
                      className="modal-image"
                    />

                    <span className="close-btn" onClick={closeModal}>
                      &#10005;
                    </span>
                  </span>
                </Modal>
              </div>
            </div>

            <div className="right">
              <form onSubmit={handleSubmit} >
                <div className="formInput">
                  <label htmlFor="img1">
                      {t("Select Logo")}: <DriveFolderUploadOutlinedIcon className="icon" />
                  </label>
                  <input
                    disabled={!updatePermission}
                    type="file"
                    id="img1"
                    // defaultValue={user.img1}

                    name="img1"
                    onChange={(e) => {
                      setImg1(e.target.files[0])
                      setNewImageSelected(true);
                    }}
                    style={{ display: "none" }}

                  />
                </div>
                <div className="formInput"></div>


                {inputs(t).map((input) => (
                  <div className="formInput" key={input.id} >

                    <label className={`${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}> {input.label}*</label>

                    <input
                      type={input.type}
                      placeholder={input.placeholder}
                      name={input.name}
                      required={input.required}
                      className={`${i18n.language === 'ar' ? "text-end" : 'text-start'}`}
                      disabled={!updatePermission}
                      defaultValue={companyData != null && companyData[input.name]}

                    />
                  </div>
                ))}


                {updatePermission && (<div className="buttonDiv"> <button type="submit">
                  {t("Update")}</button> </div>)
                }

              </form>
            </div>
          </div>


        </div>
      </div >

    </span >
  );
};

export default CompanyInfo;
